module.exports = __webpack_public_path__ + "static/media/video_play_icon.3114314a.svg";